import React from 'react';

import { format } from 'date-fns';
import { Formik } from 'formik';
import moment from 'moment';
import * as Yup from 'yup';

import Button from 'CommonComponents/Button';
import DatePickerField from 'CommonComponents/DatePickerField';
import FormTextRow from 'CommonComponents/FormTextRow';
import NumberFormat from 'CommonComponents/LocalisedNumberFormat';
import SelectFromField from 'CommonComponents/SelectFromField';
import TextareaFormField from 'CommonComponents/TextareaFormField';
import TextFormField from 'CommonComponents/TextFormField';

import 'react-datepicker/dist/react-datepicker.css';

const PolicyCreateSchema = Yup.object().shape({
    title: Yup.string().required('This value is required'),
    description: Yup.string().required('This value is required'),
    estimated_value: Yup.string().required('This value is required'),
    procurement_policy_id: Yup.string().required('This value is required'),
    contract_date: Yup.string().required('This value is required'),
});

export default function PurchaseRequisitionsEditForm(props) {
    const prCode = () => {
        return props.pr.pr_code;
    };

    return (
        <Formik
            initialValues={{
                procurement_policy_id: props.pr.procurement_policy_id,
                pr_code: prCode(),
                title: props.pr.title,
                description: props.pr.description,
                estimated_value: props.pr.estimated_value,
                is_budgeted: props.pr.is_budgeted,
                contract_date: props.pr.contract_date,
            }}
            validationSchema={PolicyCreateSchema}
            onSubmit={(values, actions) => {
                let data = { ...values };
                data.contract_date = format(new Date(values.contract_date), 'yyyy-MM-dd');

                axios
                    .put(props.updateUrl.replace('REQUISITION_ID', props.pr.id), data)
                    .then((response) => {
                        props.setPrIsUpdated(true);
                    })
                    .catch((e) => {
                        actions.setErrors(e.response.data.errors);
                    })
                    .finally(() => {
                        actions.setSubmitting(false);
                    });
            }}
        >
            {({ values, errors, touched, isSubmitting, handleSubmit, setFieldValue }) => (
                <>
                    <FormTextRow label={$t('Id')} text={prCode()}></FormTextRow>

                    <FormTextRow label={$t('Date')} text={moment().format('DD/MM/YYYY')}></FormTextRow>

                    <FormTextRow label={$t('Requestor')} text={props.pr.user.first_name + ' ' + props.pr.user.last_name}></FormTextRow>

                    <div className="tw-grid tw-grid-cols-1">
                        <TextFormField label={$t('Title')} required={true} type="text" name="title" placeholder="Title" horizontalLayout={true}></TextFormField>
                    </div>
                    <div className="tw-grid tw-grid-cols-1">
                        <TextareaFormField
                            label={$t('Description of what is being procured')}
                            as="textarea"
                            type="text"
                            name="description"
                            placeholder="Description"
                            horizontalLayout={true}
                        ></TextareaFormField>
                    </div>

                    <div className="tw-grid tw-grid-cols-3 tw-gap-4">
                        <div className="tw-col-span-1">
                            <label htmlFor="estimated_value" className="text-input__label">
                                {$t('Estimated value')} *
                            </label>
                        </div>
                        <div className="tw-col-span-2 tw-flex tw-flex-col tw-space-y-1.5">
                            <NumberFormat
                                name="estimated_value"
                                placeholder="Estimated Value"
                                value={values.estimated_value}
                                className={
                                    errors.estimated_value && touched.estimated_value ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'
                                }
                                thousandSeparator={true}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    setFieldValue('estimated_value', value);
                                }}
                            />
                            {errors.estimated_value && touched.estimated_value && <div className="tw-text-red-500 tw-text-sm">{errors.estimated_value}</div>}
                        </div>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <SelectFromField label={$t('Is the expenditure budgeted?')} as="select" name="is_budgeted" horizontalLayout={true} required={true}>
                            <option value={0}>{$t('No')}</option>
                            <option value={1}>{$t('Yes')}</option>
                        </SelectFromField>
                    </div>

                    <div className="tw-grid tw-grid-cols-1">
                        <SelectFromField
                            label={$t('Procurement Method')}
                            as="select"
                            name="procurement_policy_id"
                            horizontalLayout={true}
                            required={true}
                            showInfo={() => props.showInfo()}
                        >
                            {!values.procurement_policy_id && <option value="">{$t('Please select')}</option>}
                            {props.policies?.map((policy) => {
                                return (
                                    <option key={policy.id} value={policy.id}>
                                        {policy.method}
                                    </option>
                                );
                            })}
                        </SelectFromField>
                    </div>

                    <div className="tw-grid tw-grid-cols-3 tw-gap-4">
                        <div className="tw-col-span-1">
                            <label htmlFor="estimated_value" className="text-input__label">
                                {$t('Target Contract Date')} *
                            </label>
                        </div>
                        <div className="tw-col-span-2 tw-flex tw-flex-col tw-space-y-1.5">
                            <DatePickerField
                                name="contract_date"
                                className={errors.contract_date && touched.contract_date ? 'tw-border tw-border-red-500 text-input' : 'tw-border-0 text-input'}
                                value={values.contract_date}
                                onChange={setFieldValue}
                            />
                            {errors.contract_date && touched.contract_date && <div className="tw-text-red-500 tw-text-sm">{errors.contract_date}</div>}
                        </div>
                    </div>

                    <div className="modal__footer">
                        <Button variant="primary" disabled={isSubmitting} onClick={handleSubmit}>
                            {$t('Update')}
                        </Button>
                    </div>
                </>
            )}
        </Formik>
    );
}
